export var getGoalTypesURL = function getGoalTypesURL(_ref) {
  var _ref$gatewayBaseUrl = _ref.gatewayBaseUrl,
    gatewayBaseUrl = _ref$gatewayBaseUrl === void 0 ? '' : _ref$gatewayBaseUrl;
  return "".concat(gatewayBaseUrl, "/gateway/api/graphql?operationName=goalTypes");
};
export var getGoalTypesGraphqlPayload = function getGoalTypesGraphqlPayload(props) {
  var containerId = props.containerId;
  return JSON.stringify({
    query: "query GoalTypesQuery($containerId: String!) {\n    townsquare {\n      goalTypes(containerId: $containerId) @optIn(to: \"Townsquare\") {\n        edges {\n          node {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tname {\n\t\t\t\t\t\t\t... on TownsquareGoalTypeCustomName {\n\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t... on TownsquareLocalizationField {\n\t\t\t\t\t\t\t\tmessageId\n\t\t\t\t\t\t\t\tdefaultValue\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\ticon {\n\t\t\t\t\t\t\tkey\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t    }\n      }\n    }\n  }",
    variables: {
      containerId: "ari:cloud:townsquare::site/".concat(containerId)
    }
  });
};